import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import './App.css'
import Login from './pages/auth/Login'
import PasswordReset from './pages/auth/PasswordReset'
import VerifyEmail from './pages/auth/VerifyEmail'
import Layout from './layouts/Layout'
import PrivateRoute from './routes/PrivateRoute'
import { useAuth } from './context/AuthContext'
import PublicRoute from './routes/PublicRoute'
import ChooseInstitute from './pages/auth/ChooseInstitute'
import SetPassword from './pages/auth/SetPassword'
import PasswordVerification from './pages/auth/PasswordVerification'
import ForgetPassword from './pages/auth/ForgetPassword'
import EmailVerification from './pages/auth/EmailVerification'
import PrivacyPage from './pages/auth/PrivacyPage'
import TermsPage from './pages/auth/TermsPage'
import { returnRouter } from './routes/paths'

const routes = [
  { path: '/', element: <Login /> },
  { path: '/privacy-policy', element: <PrivacyPage /> },
  { path: '/terms-condiditions', element: <TermsPage /> },
  { path: '/password-reset', element: <PasswordReset /> },
  { path: '/setup-password', element: <SetPassword /> },
  { path: '/reset-password/:token', element: <ForgetPassword /> },
  { path: '/email-verify/:token', element: <EmailVerification /> },
  { path: '/setup-password-verification', element: <PasswordVerification /> },
  { path: '/verify-email', element: <VerifyEmail /> },
  { path: '/schools', element: <ChooseInstitute /> },
]

function App() {
  const { user, logout } = useAuth()
  let idleTimeout: NodeJS.Timeout | undefined

  const resetIdleTimeout = () => {
    clearTimeout(idleTimeout)
    idleTimeout = setTimeout(logout, 1000 * 60 * 5) // 5 minutes
  }

  useEffect(() => {
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
    ]
    const resetIdleTimeoutOnEvent = () => resetIdleTimeout()

    events.forEach((event) =>
      document.addEventListener(event, resetIdleTimeoutOnEvent)
    )
    return () =>
      events.forEach((event) =>
        document.removeEventListener(event, resetIdleTimeoutOnEvent)
      )
  }, [])

  useEffect(() => {
    resetIdleTimeout()
  }, [])

  return (
    <Routes>
      <Route path="/" element={<PublicRoute />}>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
      <Route path="/home" element={<PrivateRoute />}>
        {returnRouter(
          user?.role?.role || localStorage.getItem('userRole')
        )?.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <Layout>
                <route.component />
              </Layout>
            }
          />
        ))}
      </Route>
    </Routes>
  )
}

export default App
